import classNames from 'classnames'
import type { ReactNode } from 'react'
import styles from './EffectivenessTable.module.scss'

export interface EffectivenessTableProps {
  footnote: string
  tableHeadline?: string
  labelHormonal: string
  labelNonHormonal: string
  table: {
    icon: {
      alt: string
      url: string
    }
    id: string
    effectiveness: string
    hasHormones: boolean
    method: string
  }[]
  tablePlacement?: 'horizontal' | 'vertical'
}

export function EffectivenessTable({
  footnote,
  labelHormonal,
  labelNonHormonal,
  table,
  tableHeadline = '',
  tablePlacement = 'vertical',
}: EffectivenessTableProps): ReactNode {
  const tableClass = classNames(styles.EffectivenessTable, {
    [styles.EffectivenessTable___noHeadline]: !tableHeadline,
    [styles.EffectivenessTable___horizontal]: tablePlacement === 'horizontal',
  })
  return (
    <div uid="effectiveness-table" className={tableClass}>
      {tableHeadline && <p className={styles.EffectivenessTable__headline}> {tableHeadline} </p>}
      <p
        id="effectiveness-table-label-hormonal"
        className={styles.EffectivenessTable__labelDesktop}
      >
        {labelHormonal}
      </p>
      <div className={styles.EffectivenessTable__hormonal}>
        <p className={styles.EffectivenessTable__label}>{labelHormonal}</p>
        {table.map(item => {
          if (item.hasHormones) {
            return (
              <div className={styles.EffectivenessTable__item} key={item.id}>
                <img
                  alt={item.icon.alt}
                  className={styles.EffectivenessTable__itemIcon}
                  src={item.icon.url}
                />
                <p className={styles.EffectivenessTable__itemEffectiveness}>{item.effectiveness}</p>
                <p className={styles.EffectivenessTable__itemName}>{item.method}</p>
              </div>
            )
          }
        })}
      </div>

      <div className={styles.EffectivenessTable__nonHormonal}>
        <p className={styles.EffectivenessTable__label}> {labelNonHormonal}</p>
        {table.map(item => {
          const isNaturalCycles = /Natural Cycles/.exec(item.method)
          if (!item.hasHormones) {
            return (
              <div
                className={
                  isNaturalCycles
                    ? [styles.EffectivenessTable__itemNC, styles.EffectivenessTable__item].join(' ')
                    : styles.EffectivenessTable__item
                }
                key={item.id}
              >
                <img
                  alt={item.icon.alt}
                  className={styles.EffectivenessTable__itemIcon}
                  src={item.icon.url}
                />
                <p className={styles.EffectivenessTable__itemEffectiveness}>{item.effectiveness}</p>
                <p className={styles.EffectivenessTable__itemName}>{item.method}</p>
              </div>
            )
          }
        })}
      </div>
      <p
        id="effectiveness-table-label-non-hormonal"
        className={styles.EffectivenessTable__labelDesktop}
      >
        {labelNonHormonal}
      </p>
      <div
        className={styles.EffectivenessTable__footnote}
        dangerouslySetInnerHTML={{ __html: footnote }}
      />
    </div>
  )
}
